import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';
import SearchBox from '../common/SearchBoxComponent';
import {ExportToExcel} from '../common/ExportDataToExcelComponent';
import {camelObj} from '../common/ConversionMethod';
import LoginMethod from '../common/LoginMethod';

export default function SocietyInformationAdmin(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/admin/api!organizationAndUserInfo.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const viewClick = (item) => {
		const baseUrl = '/society/society-information';
		LoginMethod(camelObj(item), baseUrl);
	};

	const camelDataSource = dataSource?.map((data, index) => ({showIndex: index + 1, ...camelObj(data)}));

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
			width: 90,
		},
		{
			title: '社会组织名称',
			dataIndex: 'organizationName',
			width: 240,
		},
		{
			title: '类别',
			dataIndex: 'organizationType',
			width: 120,
		},
		{
			title: '发起人/发起单位',
			dataIndex: 'establishUnit',
			width: 180,
		},
		{
			title: '成立时间',
			dataIndex: 'organizationEstablishDate',
			width: 100,
		},
		{
			title: '换届时间',
			dataIndex: 'organizationTermDate',
			width: 100,
		},
		{
			title: '每届年限',
			dataIndex: 'organizationOneTermYear',
			width: 100,
		},
		{
			title: '当前届数',
			dataIndex: 'organizationCurrentTerm',
			width: 100,
		},
		{
			title: '操作',
			width: 200,
			render: (item) => (
				<>
					<Button type="link" style={{color: 'green'}} onClick={() => viewClick(item)}>查看</Button>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/policy/api!deleteUser.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const newData = camelDataSource.map(
		(
			{
				showIndex,
				organizationName,
				organizationType,
				organizationCode,
				establishUnit,
				organizationEstablishMoney,
				organizationBank,
				organizationBankAccount,
				organizationEvaluationGrade,
				organizationPublicWx,
				organizationSubdiscipline,
				organizationWorkPeopleCount,
				organizationEstablishDate,
				organizationTermDate,
				organizationOneTermYear,
				organizationCurrentTerm,
				status,
				organizationMemo,
			},
		) => (
			{
				'序号': showIndex,
				'社会组织名称': organizationName,
				'类别': organizationType,
				'组织机构代码': organizationCode,
				'发起人/发起单位': establishUnit,
				'开办资金（万元）': organizationEstablishMoney,
				'开户行名称': organizationBank,
				'开户行账号': organizationBankAccount,
				'评估等级': organizationEvaluationGrade,
				'公众号': organizationPublicWx,
				'学科类别': organizationSubdiscipline,
				'从业人数': organizationWorkPeopleCount,
				'成立时间': organizationEstablishDate,
				'换届时间': organizationTermDate,
				'每届年限': organizationOneTermYear,
				'当前届数': organizationCurrentTerm,
				'当前状态': status,
				'学会简介': organizationMemo,
			}
		),
	);

	return (
		<>
			<ExportToExcel tableData={newData}/>
			<SearchBox placeholder="请输入社会组织或单位关键字"/>
			<TableComponent dataSource={camelDataSource} columns={columns}/>
		</>
	);
}

